import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

import { ButtonColors } from '@ed---interne/ng-uui-components';
import { EnedisConsentService, EnedisConsent } from '../enedis-consent.service';

import { parseJwt } from 'src/app/shared/all.helpers';
import { EnedisAccessRightStatus } from '../../../enedis.models';

@Component({
    selector: 'app-enedis-consent-page',
    templateUrl: './enedis-consent-page.component.html',
    styleUrls: ['./enedis-consent-page.component.scss'],
})
export class EnedisConsentPageComponent {
    public EnedisAccessRightStatus = EnedisAccessRightStatus;
    public buttonColors = ButtonColors;

    consentForm: FormGroup;
    token: string | null = null;
    consentGiven: boolean = false;

    loading: boolean = true;
    error: boolean = false;
    consentData: Partial<EnedisConsent> | null = null;
    clientCompany: string | null = null;

    constructor(
        private fb: FormBuilder,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private enedisConsentService: EnedisConsentService,
    ) {
        this.consentForm = this.fb.group({
            dataConsumption: [false, Validators.requiredTrue],
            profileData: [false, Validators.requiredTrue],
            technicalData: [false, Validators.requiredTrue],
        });
    }

    async ngOnInit(): Promise<void> {
        this.activatedRoute.queryParams.subscribe(async (params) => {
            this.token = params['token'];

            if (!this.token) {
                this.error = true;
                console.error('Token is missing');
                this.loading = false;
                return;
            }

            try {
                const consentStatus = await this.enedisConsentService.getEnedisConsentStatus(
                    this.token,
                );

                this.consentData = parseJwt(this.token) as Partial<EnedisConsent>;
                this.consentData.status = consentStatus.status;

                if (this.consentData!.clientSirenSiret) {
                    this.clientCompany = [
                        this.consentData.clientName,
                        this.consentData.clientSirenSiret,
                    ].join(' / ');
                }
            } catch (err: any) {
                console.error('Error getting current consent status', err);
                this.error = true;
            } finally {
                this.loading = false;
            }
        });
    }

    async onAccept() {
        if (this.consentForm.valid) {
            try {
                const result = await this.enedisConsentService.updateConsent(
                    this.token!,
                    EnedisAccessRightStatus.ACTIVE,
                );

                if (result.status === EnedisAccessRightStatus.ACTIVE) {
                    this.consentGiven = true;
                }
            } catch (err: any) {
                console.error('Error accepting consent', err);
                this.error = true;
            }
        }
    }

    async onRevoke() {
        this.router.navigate(['/enedis-consent/revoked'], { queryParams: { token: this.token } });
    }
}
